import * as yup from "yup";

export const schema = (t: (val: string) => string) => {
    const validation = {
        name: yup.string().required(t("cmn:val.required")),
        trainingYears: yup.array().of(
            yup.object().shape({
                code: yup.string().required(t("cmn:val.required")),
                color: yup.string().required(t("cmn:val.required")),
                year: yup.string().required(t("cmn:val.required")),
            })
        ),
    };

    return yup.object().shape({ ...validation });
};
